import {
  Alert,
  Avatar,
  CardHeader,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { AnalysisPopover } from "../AnalysisPopover/AnalysisPopover";
import {
  SeverityRow,
  PackageAnalysisAggregateLineItem,
} from "@interfaces/analysis";
import { useState } from "react";
import { SocialCommitmentTypeHour } from "@interfaces/commitment";
import { getSeverityColour } from "@utils/color";
import { LegendPopover } from "../LegendPopover/LegendPopover";
import { reportStatusToColor } from "@interfaces/contractorReport";
import { DataLoadingRow } from "../ListTable/DataLoadingRow";

interface ContractorAnalyticsLabourHoursProps {
  analysis: PackageAnalysisAggregateLineItem[];
}
export const ContractorAnalyticsLabourHours = ({
  analysis,
}: ContractorAnalyticsLabourHoursProps) => {
  const [legendAnchorElement, setLegendAnchorElement] = useState<
    Element | undefined
  >(undefined);

  const [anchorElement, setAnchorElement] = useState<Element | undefined>(
    undefined
  );

  const [severityRow, setSeverityRow] = useState<SeverityRow | undefined>(
    undefined
  );

  const onLeaveLegend = () => {
    console.log("On leave");
    setLegendAnchorElement(undefined);
  };
  const onEnterLegend = (event: any) => {
    console.log("On enter");
    setLegendAnchorElement(event.target);
  };

  const onLeave = () => {
    console.log("On leave");
    setSeverityRow(undefined);
    setAnchorElement(undefined);
  };
  const onEnter = (event: any, selectedSeverityRow: SeverityRow) => {
    console.log("On enter");
    setAnchorElement(event.target);
    setSeverityRow(selectedSeverityRow);
  };
  const loading = false;

  const getSeverity = (
    item: PackageAnalysisAggregateLineItem,
    commitmentType: SocialCommitmentTypeHour
  ): SeverityRow => {
    const total = 0;
    const totalTarget = 0;
    const pcChange = 0;
    // switch (commitmentType) {
    //   default:
    //     break;
    //   case SocialCommitmentTypeHour.LocalJobsFirst:
    //     total = item.localJobsFirst.achieved;
    //     totalTarget = item.localJobsFirst.target;
    //     pcChange = item.localJobsFirst.pcChange;
    //     break;
    //   case SocialCommitmentTypeHour.AboriginalTorresStraitIslanderParticipation:
    //     total = item.indigHours.achieved;
    //     totalTarget = item.indigHours.target;
    //     pcChange = item.indigHours.pcChange;
    //     break;
    //   case SocialCommitmentTypeHour.MPSGHoursRequirement:
    //     total = item.mpsgHours.achieved;
    //     totalTarget = item.mpsgHours.target;
    //     pcChange = item.mpsgHours.pcChange;
    //     break;
    //   case SocialCommitmentTypeHour.FemaleParticipation:
    //     total = item.femaleHours.achieved;
    //     totalTarget = item.femaleHours.target;
    //     pcChange = item.femaleHours.pcChange;
    //     break;
    //   case SocialCommitmentTypeHour.OpportunitiesForDisadvantagedVictorians:
    //     total = item.disAdvHours.achieved;
    //     totalTarget = item.disAdvHours.target;
    //     pcChange = item.disAdvHours.pcChange;
    //     break;
    // }

    let ratio = 0;
    if (totalTarget > 0) {
      ratio = total / totalTarget;
    }
    const severity = getSeverityColour(ratio);
    return {
      severity,
      total,
      totalTarget,
      pcChange,
      ratio,
      label: `${(ratio * 100).toLocaleString()}%`,
    };
  };

  return (
    <>
      <Table style={{ tableLayout: "fixed" }}>
        <TableHead>
          <TableCell>Package No.</TableCell>
          <TableCell>Subcontractor</TableCell>
          <TableCell>Report Submitted</TableCell>
          <TableCell>MPSG</TableCell>
          <TableCell>Indigenous Hours</TableCell>
          <TableCell>Disadvantaged Victorians</TableCell>
          <TableCell>Female Participation</TableCell>
          <TableCell>Family Violence Leave Policy</TableCell>
          <TableCell>Environmental Sustainability</TableCell>
        </TableHead>
        {!loading && analysis
          ? analysis?.map((p, index) => {
              const dataMpsg = getSeverity(
                p,
                SocialCommitmentTypeHour.MPSGHoursRequirement
              );
              const dataLjf = getSeverity(
                p,
                SocialCommitmentTypeHour.LocalJobsFirst
              );
              const dataIndi = getSeverity(
                p,
                SocialCommitmentTypeHour.AboriginalTorresStraitIslanderParticipation
              );
              const dataDis = getSeverity(
                p,
                SocialCommitmentTypeHour.OpportunitiesForDisadvantagedVictorians
              );
              const dataFem = getSeverity(
                p,
                SocialCommitmentTypeHour.FemaleParticipation
              );
              return (
                <TableRow>
                  <TableCell>{`#${index + 1}`}</TableCell>
                  <TableCell>
                    <Tooltip title={p.contractorName}>
                      <CardHeader
                        avatar={
                          <Avatar
                            src={p.contractorLogo}
                            alt={
                              p.contractorName.length > 0
                                ? p.contractorName[0].toUpperCase()
                                : "Unknown"
                            }
                          />
                        }
                        title={""}
                      />
                    </Tooltip>
                  </TableCell>
                  <TableCell
                    align="center"
                    onMouseEnter={onEnterLegend}
                    onMouseLeave={onLeaveLegend}
                  >
                    <Alert
                      variant="filled"
                      severity={reportStatusToColor(p.reportStatus)}
                      sx={{
                        margin: "auto !important",
                        "& .MuiAlert-icon": { margin: "auto important!" },
                      }}
                    ></Alert>
                  </TableCell>
                  <TableCell
                    onMouseEnter={(event: any) => onEnter(event, dataMpsg)}
                    onMouseLeave={onLeave}
                  >
                    <Alert variant="filled" severity={dataMpsg.severity}>
                      {dataMpsg.label}
                    </Alert>
                  </TableCell>
                  <TableCell
                    onMouseEnter={(event: any) => onEnter(event, dataIndi)}
                    onMouseLeave={onLeave}
                  >
                    <Alert variant="filled" severity={dataIndi.severity}>
                      {dataIndi.label}
                    </Alert>
                  </TableCell>
                  <TableCell
                    onMouseEnter={(event: any) => onEnter(event, dataMpsg)}
                    onMouseLeave={onLeave}
                  >
                    <Alert variant="filled" severity={dataDis.severity}>
                      {dataDis.label}
                    </Alert>
                  </TableCell>
                  <TableCell
                    onMouseEnter={(event: any) => onEnter(event, dataFem)}
                    onMouseLeave={onLeave}
                  >
                    <Alert variant="filled" severity={dataFem.severity}>
                      {dataFem.label}
                    </Alert>
                  </TableCell>
                  <TableCell>
                    <Alert variant="filled" severity="error">
                      -
                    </Alert>
                  </TableCell>
                  <TableCell>
                    <Alert variant="filled" severity="error">
                      -
                    </Alert>
                  </TableCell>
                </TableRow>
              );
            })
          : null}
        {analysis && analysis?.length === 0 && !loading ? (
          <TableRow>
            <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
              <Typography paragraph>No Packages</Typography>
            </TableCell>
          </TableRow>
        ) : null}
        {loading ? <DataLoadingRow colSpan={9} /> : null}
      </Table>
      {severityRow ? (
        <AnalysisPopover
          severityRow={severityRow}
          anchorElement={anchorElement}
          handleCloseMenu={function (): void {
            setSeverityRow(undefined);
            setAnchorElement(undefined);
          }}
        />
      ) : null}
      {legendAnchorElement ? (
        <LegendPopover
          anchorElement={legendAnchorElement}
          handleCloseMenu={function (): void {
            setLegendAnchorElement(undefined);
          }}
        />
      ) : null}
    </>
  );
};
